import { cn } from "@utils/tw"
import { motion } from "motion/react"
import { ReactNode, useEffect, useState } from "react"

export const Expandable = ({
  anchor,
  startOpen = env.admin,
  label,
  icon,
  iconOpen,
  children,
  className,
  buttonClassName,
  contentClassName,
  onOpenChange,
}: {
  anchor?: string
  startOpen?: boolean
  label: ReactNode
  icon?: ReactNode
  iconOpen?: ReactNode
  children: ReactNode
  className?: string
  buttonClassName?: string
  contentClassName?: string
  onOpenChange?: (open: boolean) => void
}) => {
  const [open, setOpen] = useState(startOpen)
  const IconOpen = iconOpen === undefined ? icon : iconOpen
  const Icon = open ? IconOpen || icon : icon

  useEffect(() => {
    setOpen(startOpen)
  }, [startOpen])

  useEffect(() => {
    onOpenChange?.(open)
  }, [open, onOpenChange])

  return (
    <div className={cn("w-full flex flex-col justify-between items-center group relative", className)}>
      <a id={anchor} className="block w-full">
        <button
          className={cn(
            "w-full flex items-center justify-between type-sans-base-semibold text-left gap-4 cursor-pointer",
            buttonClassName,
          )}
          onClick={() => setOpen(env.admin || !open)}
        >
          <div className="w-full flex justify-start items-center">{label}</div>
          <div
            className={cn(
              "flex items-center justify-center",
              // "transition-transform duration-300",
              // open && "rotate-180",
            )}
          >
            {Icon}
            {!Icon && icon !== false && (
              <svg className="w-[1rem] h-[1rem]" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line y1="7" x2="15" y2="7" stroke="currentColor" />
                <line x1="8" x2="8" y2="15" stroke="currentColor" />
              </svg>
            )}
          </div>
        </button>
      </a>
      <motion.div
        className={cn("w-full", !open && "overflow-hidden")}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
      >
        <div className={cn("pt-2 pb-0", contentClassName)}>{children}</div>
      </motion.div>
    </div>
  )
}
